module.exports = __webpack_public_path__ + "1792395595471/images/mastercard.7bbc1c0.png";